import * as React from 'react';
import { UIHeading4, UIText2, Spinner } from '@cian/ui-kit';
import classNames from 'classnames';
import packageImgSrc from './assets/package.png';
import * as styles from './PackagePaymentStatus.css';
import { EPaymentStatus } from '../../../../../../types/reducers/paymentProcessing';

interface IProps {
  status: EPaymentStatus;
  isMobile: boolean;
  onRetryClick(): void;
}

export const PackagePaymentStatus = ({ status, isMobile, onRetryClick }: IProps) => {
  return (
    <div className={classNames(styles['wrapper'], isMobile && styles['mobile'])}>
      <div className={styles['content']}>
        <img className={styles['icon']} width={32} height={32} src={packageImgSrc} />

        <div>
          <UIHeading4>Покупаем пакет</UIHeading4>

          <UIText2>Сможете его использовать, как только пройдет оплата</UIText2>
        </div>

        {status === EPaymentStatus.Pending && (
          <div className={styles['spinner']}>
            <Spinner size={20} />
          </div>
        )}
      </div>

      {status === EPaymentStatus.Canceled && (
        <div className={classNames(styles['link'], isMobile && styles['mobile'])} onClick={onRetryClick}>
          <UIText2 fontWeight="700" color="fill_primary_active_100">
            Обновить
          </UIText2>
        </div>
      )}
    </div>
  );
};
